// src/routes/AppRoutes.js
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import pharmacyRoutes from "./PharmacyRoutes/PharmacyRoutes";
import patientProfileRoutes from "./PatientProfile/PatientProfile";
import financeRoutes from "./FinanceRoutes/FinanceRoutes";
import humanResourceRoutes from "./HRRoutes/HRRoutes";
import SignInView from "../pages/Authentication/SignIn/SignIn";
export const createAppRouter = (permissions) => {
  // Conditionally add routes based on permissions
  const childrenRoutes = [
    permissions.pharmacy && pharmacyRoutes,
    permissions.finance && financeRoutes,
    permissions.hr && humanResourceRoutes,
  ].filter(Boolean);

  return createBrowserRouter([
    {
      path: "/",
      element: <App />,
      children: [...childrenRoutes, patientProfileRoutes],
    },
    { path: "user/sign-in/", element: <SignInView /> },
    { path: "*", element: <Navigate to={"/"} /> },
  ]);
};
